import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';

import { BuscadorSolicitudService } from './solicitudes/buscador-solicitud.service';
import { BuscadorSolicitudListComponent } from './solicitudes/buscador-solicitud-list.component';
import { BuscadorProductoListComponent } from './productos/buscador-producto-list.component';
import { BuscadorProductoService } from './productos/buscador-producto.service';
import { RechazosTracesWrapperComponent } from './rechazostraces/rechazostraces-wrapper/rechazostraces-wrapper.component';
import { RechazosTracesWrapperParteIComponent } from './rechazostraces/rechazostraces-wrapper-parte-i/rechazostraces-wrapper-parte-i.component';
import { RechazosTracesWrapperParteIIComponent } from './rechazostraces/rechazostraces-wrapper-parte-ii/rechazostraces-wrapper-parte-ii.component';
import { RechazosTracesWrapperNoCumplimientoComponent } from './rechazostraces/rechazostraces-wrapper-no-cumplimiento/rechazostraces-wrapper-no-cumplimiento.component';
import { RechazosTracesService } from './rechazostraces/rechazostraces.service';
import { RechazosTracesFilterComponent } from './rechazostraces/rechazostraces-filter/rechazostraces-filter.component';
import { RechazosTracesListComponent } from './rechazostraces/rechazostraces-list/rechazostraces-list.component';
import { RechazosTracesParteIComponent } from './rechazostraces/rechazostraces-parte-i/rechazostraces-parte-i.component';
import { RechazosTracesParteIIComponent } from './rechazostraces/rechazostraces-parte-ii/rechazostraces-parte-ii.component';
import { RechazosTracesNoCumplimientoComponent } from './rechazostraces/rechazostraces-no-cumplimiento/rechazostraces-no-cumplimiento.component';
import { BuscadoresRoutingModule } from './buscadores-routing.module';

@NgModule({
    declarations: [
        BuscadorSolicitudListComponent,
        BuscadorProductoListComponent,
        RechazosTracesWrapperComponent,
        RechazosTracesWrapperParteIComponent,
        RechazosTracesWrapperParteIIComponent,
        RechazosTracesWrapperNoCumplimientoComponent,
        RechazosTracesFilterComponent,
        RechazosTracesListComponent,
        RechazosTracesParteIComponent,
        RechazosTracesParteIIComponent,
        RechazosTracesNoCumplimientoComponent,
    ],
    exports: [],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, BuscadoresRoutingModule],
    providers: [BuscadorSolicitudService, BuscadorProductoService, RechazosTracesService],
})
export class BuscadoresModule {}
